module.exports = __webpack_public_path__ + "static/media/02_01.424a1260.png";